export default function($) {
  $('h1, .title-home').each(function(index) {
    var $element = $(this);
    var text = $element.html();
    var index = text.indexOf('<br>');
    if ($element.html().includes('<br>')) {
      if (index !== -1) {
        var before = text.substring(0, index);
        var after = text.substring(index + 4);

        $element.html('<span class="animate-in slide-in-from-bottom-12 fade-in duration-500">' + before + '</span><br><span class="animate-in slide-in-from-bottom-12 fade-in duration-1000">' + after + '</span>');
        $element.removeClass('opacity-0').addClass('opacity-100');
      }
    } else {
      $element.addClass('animate-in slide-in-from-bottom-24 fade-in duration-1000');
    }
  });
}
